import * as React from 'react';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { RealtorRequestTrapContainer } from 'shared/containers/valuationTraps';
import { CPDBannerTrapContainer } from 'shared/containers/valuationTraps/CPDTrapContainer/CPDBannerTrap/CPDBannerTrapContainer';
import { EValuationTrap } from 'shared/containers/valuationTraps/CPDTrapContainer/CPDBannerTrap/types';
import { useCpdOrCplTrapVisible } from 'shared/containers/valuationTraps/hook/useCpdOrCplTrapVisible';

export const BannerTrapContainerLoader: React.FC = () => {
  const trapType = useCpdOrCplTrapVisible();

  switch (trapType) {
    case EValuationTrap.cpd:
      return (
        <CardSectionNew hideForPrint>
          <CPDBannerTrapContainer />
        </CardSectionNew>
      );
    case EValuationTrap.cpl:
      return (
        <CardSectionNew hideForPrint withBorders>
          <RealtorRequestTrapContainer withoutBorders={true} />
        </CardSectionNew>
      );
    default:
      return null;
  }
};
